import React, { useState, useEffect } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { dataService } from '../../Services/data.service';
import { toast } from 'react-toastify';
import TransportOrdersTable from './TransportOrdersTable';
import { useTranslation } from 'react-i18next';

export default function TransportOrdersDrawer(props) {
    const classes = useStyles();

    const [activeOrders, setActiveOrders] = useState([]);
    const [orderHistory, setOrderHistory] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        let mounted = true

        dataService.getActiveTransportOrders().then(orders => {
            if (mounted) {
                setActiveOrders(orders.body)
            }
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        dataService.getTransportOrdersHistory().then(history => {
            if (mounted) {
                setOrderHistory(history.body)
            }
        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        return function cleanup() {
            mounted = false
        }
    }, []);

    return <Drawer variant="temporary" className={classes.drawer} anchor='right' open={props.drawerOpen} classes={{ paper: clsx({ [classes.drawerOpen]: props.drawerOpen, [classes.drawerClose]: !props.drawerOpen, }), }} onClose={() => props.openDrawer(false)} transitionDuration={500}>

        <div className={classes.drawerBody}>
            <div className={classes.header}>
                <div className={classes.title}>{t("Transport orders")}</div>
                <div className={classes.close}>
                    <Button className={classes.closeButton} onClick={() => props.openDrawer(false)}><CloseIcon></CloseIcon></Button>
                </div>
            </div>
            <div className={classes.activeTransport}>
                <div className={classes.tableTitle}>
                    {t("Active transport")}
                </div>
                <div className={classes.activeTransportTableContainer}>
                    {activeOrders && <TransportOrdersTable orders={activeOrders}></TransportOrdersTable>}
                </div>
            </div >
            <div className={classes.transportHistory}>
                <div className={classes.tableTitle}>
                    {t("Transport history")}
                </div>
                <div className={classes.transportHistoryTableContainer}>
                    {orderHistory && <TransportOrdersTable orders={orderHistory}></TransportOrdersTable>}
                </div>
            </div>
        </div>
    </Drawer>
}

const useStyles = makeStyles(() => ({

    saveButton: {
        backgroundColor: "#5CC958",
        color: "white"
    },

    drawerBody: {
        width: "100%",
        padding: "40px",
        paddingRight: "0px",
        paddingTop: "0px",
        boxSizing: "border-box"
    },

    closeButton: {
        float: "right",
        "&:hover": {
            background: "#EFEFEF"
        },
        minWidth: "36px !important",
        width: "36px",
    },

    drawerOpen: {
        width: "80%",
        background: "linear-gradient(#EFEFEF,#FFFFFF)"
    },

    drawerClose: {
        width: 0
    },
    header: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        width: "100%",
        height: '70px'
    },
    tableTitle: {
        fontSize: "21px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        marginBottom: "20px"
    },
    title: {
        width: "70%",
        float: 'left',
        marginTop: "30px"
    },
    activeTransport: {
        marginTop: "20px",
        marginBottom: "30px",
        marginRight: "40px"
    },
    transportHistory: {
        marginRight: "40px"
    }

}));